module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO53Felicitaciones.a5a0c64.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO53Felicitaciones.mp4
// module id = 779
// module chunks = 1